import { FilterModalTypes } from '.';

export const getInitialRangeErrors = (filters: FilterModalTypes.FilterType[]) => {
  return filters
    .filter(({ type }) => type === 'range')
    .map(({ fieldName }) => ({ fieldName, error: false }));
};

export const getEmptySelections = (filters: FilterModalTypes.FilterType[]) =>
  filters.map((filter) => {
    switch (filter.type) {
      case 'autocomplete':
        return { fieldName: filter.fieldName, filter: filter.selection || null };

      case 'date':
        return { fieldName: filter.fieldName, filter: filter.selection || null };

      case 'dateRange':
        return { fieldName: filter.fieldName, filter: filter.selection || {} };

      case 'multiSlider':
        return { fieldName: filter.fieldName, filter: filter.selection || {} };

      case 'section':
        return { fieldName: filter.fieldName, filter: filter.selection || [] };

      case 'tags':
        return { fieldName: filter.fieldName, filter: filter.selection || [] };

      case 'select':
        return { fieldName: filter.fieldName, filter: filter.selection || null };

      case 'range':
        return { fieldName: filter.fieldName, filter: filter.selection || {} };

      case 'boolean':
        return { fieldName: filter.fieldName, filter: filter.selection || [] };
    }
  });
